import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Heading, Card, Form } from 'react-bulma-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock } from '@fortawesome/free-solid-svg-icons';
import { signInWithEmail } from '../js/firebase/config';
import styles from '../styles/login.module.css';
import holorayLogo from '../assets/images/png/logo_holoray_black.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      await signInWithEmail(email, password);
      navigate('/');
    } catch (error: any) {
      let errorMessage = 'An error occurred during authentication';
      
      switch (error.code) {
        case 'auth/invalid-credential':
            errorMessage = 'No account found with this credentials';
            break;
        case 'auth/invalid-email':
          errorMessage = 'Please enter a valid email address';
          break;
        case 'auth/user-not-found':
          errorMessage = 'No account found with this email address';
          break;
        case 'auth/wrong-password':
          errorMessage = 'Incorrect password';
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Too many failed attempts. Please try again later';
          break;
        case 'auth/user-disabled':
          errorMessage = 'This account has been disabled';
          break;
        default:
          errorMessage = error.message || errorMessage;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <Container>
        <div className={styles.loginContainer}>
          <Card className={styles.loginCard}>
            <Card.Content>
              <div className={styles.logoContainer}>
                <img 
                  src={holorayLogo}
                  alt="HoloRay Logo" 
                  className={styles.logo}
                />
              </div>
              
              {/* <Heading size={3} className={styles.title}>
                Welcome Back
              </Heading> */}
              
              <p className={styles.subtitle}>
                Sign in to access your virtual collaboration space
              </p>

              {error && (
                <div className={styles.errorMessage}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <Form.Field>
                  <Form.Label className={styles.formLabel}>Email</Form.Label>
                  <Form.Control className={styles.formControl}>
                    <Form.Input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={styles.formInput}
                      required
                    />
                    <span className={styles.inputIcon}>
                      <FontAwesomeIcon icon={faEnvelope} />
                    </span>
                  </Form.Control>
                </Form.Field>

                <Form.Field>
                  <Form.Label className={styles.formLabel}>Password</Form.Label>
                  <Form.Control className={styles.formControl}>
                    <Form.Input
                      type="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className={styles.formInput}
                      required
                    />
                    <span className={styles.inputIcon}>
                      <FontAwesomeIcon icon={faLock} />
                    </span>
                  </Form.Control>
                </Form.Field>

                <Button
                  type="submit"
                  color="primary"
                  size="large"
                  fullwidth
                  loading={loading}
                  className={styles.submitButton}
                >
                  <FontAwesomeIcon 
                    icon={faEnvelope} 
                    className={styles.buttonIcon} 
                  />
                  {loading ? 'Signing In...' : 'Sign In'}
                </Button>
              </form>

              <div className={styles.contactInfo}>
                <p>
                  Need an account? Please contact support@holoray.com.
                </p>
              </div>

              <div className={styles.terms}>
                <p>
                  By signing in, you agree to our{' '}
                  <a href="#" className={styles.link}>Terms of Service</a> and{' '}
                  <a href="#" className={styles.link}>Privacy Policy</a>
                </p>
              </div>
            </Card.Content>
          </Card>
        </div>
      </Container>
    </div>
  );
} 